import { createSlice } from "@reduxjs/toolkit";

// Slice
const SelectedSeller = JSON.parse(localStorage.getItem("SelectedSeller"));
const rootSlice = createSlice({

	name: "root",

	initialState: {
		SelectedSellerRDX: SelectedSeller || {},
		alertBarCount: 0
	},

	reducers: {
		selectedSellerRDX: (state, action) => {
			state.SelectedSellerRDX = action.payload;
		},
		setAlertBarCount: (state, action) => {
			state.alertBarCount = action.payload;
		}
	}

});

// Actions
export const {
	selectedSellerRDX,
	setAlertBarCount
} = rootSlice.actions;

export const reducer = rootSlice.reducer;
